import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import DetailProduct from './DetailProduct';
import MocktailsScreen from './mocktail';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
        const [dataDish, setDataDish] = useState(false); 
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [visibleMenu, setvisibleMenu] = useState(true);
    const [dataapptizers, setdataapptizers] = useState(false);
    const [dataOysters, setdataOysters] = useState(false);
    const [fatherdata, setfatherdata] = useState(false);
     const [showMocktails, setshowMocktails] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 252) {
                setdataapptizers(item.menus);
            }

            if (item.id === 631) {
                setfatherdata(item);
            }
        });
    }, [menus]);


    useEffect(() => {
        if (dataapptizers) {
            dataapptizers.map((item) => {
                if (item.id === 4985) {
                    setdataOysters(item);
                }
            });
        }
    }, [dataapptizers]);


   



    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setvisibleMenu(false);
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            getInitData();
            const scrollDiv = document.getElementById("mi-scroll-container");
            if (scrollDiv) {
                // reinicia la posición de scroll
                scrollDiv.scrollTop = 0;
            }

        } else if (document.visibilityState === "visible") {
            setvisibleMenu(true);
            const scrollDiv = document.getElementById("mi-scroll-container");
            if (scrollDiv) {
                // reinicia la posición de scroll
                scrollDiv.scrollTop = 0;
            }
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

        window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={setShowSpecials}>
            <div>
                <div style={{display: 'flex', width: '100%', marginTop: 10, position: 'relative',zIndex: 100}}>
                    <div style={{ width: '50%' }}>
                        <video
                            src={require('./assets/banner.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                width: 300,
                                height: 530,
                                objectFit: 'cover',
                                borderRadius: 14,
                                marginTop: 22,
                            }}
                        />

                    </div>
                    <div style={{ width: '50%', paddingLeft: 12 }}>
                            
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: 220,
                                height: 170,
                                justifyContent: 'center',
                                objectFit: 'contain',
                                zIndex: 100,
                                alignSelf: 'center',
                                  pointerEvents: 'none',
                                   marginTop: -40,
                                
                            }}
                            src={require('./assets/logo.jpg')}
                        />
                        
                            {visibleMenu &&  <div  id="mi-scroll-container" style={{height: 380, overflow: 'scroll' ,  marginTop: -22,} }>
                            <div
                                style={{
                                   
                                    display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                            }}>
                                {menus.map((item, key) => {
                                    if (item.id != 339 && item.id != 340 && item.id != 341 && item.id != 668 && item.id != 669 && item.id != 670 && item.id != 671 && item.id != 672 && item.id != 673 && item.id != 674 && item.id != 675 && item.id != 676 && item.id != 677) {
                                        return (
                                            <div
                                                onClick={() => {

                                                    if (item.id === 342) {
                                                        setShowHappy(true)
                                                    }else if (item.id === 343) {
                                                        SetshowExecutiveMenu(true)
                                                    } else if (item.id === 679) { setshowMocktails(true) } else {
                                                        setShowListProduct(true)
                                                        setdishs(item)
                                                    }
                                                }}
                                                style={{
                                                    width: 175,
                                                    height: 85,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/bk2.png')} style={{
                                                            width: '100%',
                                                        height: 100,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 13,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Milker',
                                                        }}>
                                                            {item.name}
                                                        </p>
                                                </div>
                                            
                                        </div>
                                        );
                                    }
                                })}
                            </div>
                        </div>}
                       
                        {visibleMenu && <div
                           onClick={()=>{setShowBar(true)}}
                            style={{
                                display: 'flex',
                                width: '100%',
                                alignItems: 'center',
                                marginBottom: 20,
                                justifyContent: 'center',
                                marginTop: 10,
                            }}>
                            <img
                                style={{width: 300, height: 70, objectFit: 'contain'}}
                                src={require('./assets/bar.png')}
                            />
                            <p
                                style={{
                                position: 'absolute',
                                fontSize: 13,
                                color: 'white',
                                        textTransform: 'uppercase',
                                 fontFamily: 'Milker',
                                }}>
                                BAR
                            </p>
                            </div>}
                       
                            <p
                                style={{
                                    color: '#B8A8A8',
                                    textAlign: 'center',
                                    fontSize: 12,
                                    fontWeight: '500',
                                }}>
                                Please inform the waiter if you have any type of allergic
                                condition.
                            </p>
                        </div>
                </div>
               
            </div>

            <div
                onClick={() => {
                //    setShowDetailProduct(true);
                //     setDataDish({ dish: dataOysters, alldish: [], currentDish: dataOysters })
                    // setShowListProduct(true)
                    // setdishs(fatherdata)
                }}
                style={{
                    width: '95%',
                    alignItems: 'center',
                    
                    
                    margin: '10px auto',
                }}>
                <img
                    onContextMenu={(e) => e.preventDefault()}
                    src={require('./assets/banner.png')}
                    style={{
                    width: '100%',
                        height: 170,
                      pointerEvents: 'none',
                    objectFit: 'contain',
                    borderRadius: 15,
                    }}
                />
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
                {showBar && <BarScreen setShowBar={setShowBar} />}
                 {showMocktails && <MocktailsScreen goHome={setShowBar} setShowListProduct={setshowMocktails} />}

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}
            
            
                
            </LayoutContent>
            <video
          onContextMenu={(e) => e.preventDefault()}
          loop autoPlay={true} muted 
            src={require('./assets/lights.mp4')}
            style={{
              width: '100%',
              height: 150,
              objectFit: 'cover',
              position: 'absolute',
              bottom: -40,
              right: 0,
               pointerEvents: 'none',
              zIndex: 100
            }}
          />
            </div>
    );
}

export default Index;